import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import EnterLinkCodePage from './EnterLinkCodePage';
import { saveEnterLinkCodeForm } from '../../store/dataCapture';
import { LINK_CODE_KEY, SECONDARY } from '../../utils/constants';
import * as analytics from '../../utils/analytics';

const EnterLinkCodeSection = ({ saveEnterLinkCodeForm, getBusinessData }) => {
  analytics.updateApplicant(SECONDARY);
  return (
    <EnterLinkCodePage
      saveEnterLinkCodeForm={saveEnterLinkCodeForm}
      getBusinessData={getBusinessData}
    />
  );
};

EnterLinkCodeSection.propTypes = {
  saveEnterLinkCodeForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveEnterLinkCodeForm
};

const mapStateToProps = state => ({
  getBusinessData: { link_code: selectors.getSingleEntry(state, LINK_CODE_KEY) }
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EnterLinkCodeSection);
